module.exports = __webpack_public_path__ + "img/jisukuai3_icon.cde85685.png";